// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail_SB_l6","listWrap":"detail_listWrap_1VQhx","action":"detail_action_2QjSt","alarmPhoto":"detail_alarmPhoto_2od9V"};